/**
 * Проблема в компоненте DiscUnionEd, если он соответствует optional-значению
 * Типичные ситуации - view.component и edit.component. Они могут оставаться незаполненными.
 * Для случая, когда ничего не выбрано, структура компонента примерно такая:
 * +-- DiscUnionEd path=[component]---------------+
 * | +-- Form.Item name=[component.type]-------+  |
 * | | +-- Select ------------------+          |  |
 * | | |  Не выбрано                |          |  |
 * | | +----------------------------+          |  |
 * | +-----------------------------------------+  |
 * +----------------------------------------------+
 * К сожалению, форма формирует из этого такие данные:
 * component: {
 *   type: undefined
 * }
 * Но в структуре данных поле type является обязательным.
 * Поэтому такая структура даёт ошибку парсинга.
 * А правильный вариант для данного случая:
 *  component: undefined
 * Но на уровне компонента формы такое преобразование выполнить не получается.
 * Поэтому нужно фильтровать данные и удалять из них некорректные.
 * Если это делать основываясь только на схеме, то будет сложно и не особо надёжно.
 * Найдено компромисное решение.
 * В компонент DiscUnionEd внедрён невидимый Form.Item name=[...path._discriminator#name], который содержит название поля-дискриминатора
 * Это даёт формальный признак, по которому можно удалить некорректное поле.
 * (Сначала была идея _discriminator=name, но форма постоянно синхронизируется со стором и происходит ресет кастомного поля.
 * Поэтому надёжным вариантом является _discriminator#name=any)
 */
export const filterOptionalDiscUnions = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(filterOptionalDiscUnions);
  }
  if (value && typeof value === "object") {
    const union = value as Record<string, unknown>;
    const discKey = Object.keys(union).find((key) =>
      key.startsWith(discPrefix),
    );
    if (discKey) {
      const discField = discKey.slice(discPrefix.length);
      if (!union[discField]) return undefined;
    }
    const result: Record<string, unknown> = {};
    Object.entries(union).forEach(([key, obj]) => {
      if (!key.startsWith(discPrefix))
        result[key] = filterOptionalDiscUnions(obj);
    });
    return result;
  }
  return value;
};
const discPrefix = "_discriminator#";
